import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Rule, RuleInterface, StringEquals } from '@vendasta/automata';
import { PartnerFreeTrialCancellationReasons } from './partner-cancellation-reasons';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  selector: 'automata-partner-free-trial-cancellation-reason-panel',
  templateUrl: './partner-free-trial-cancellation-reason-panel.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class PartnerFreeTrialCancellationReasonPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  cancelReason = '*'; // Init to "Any" wildcard
  cancelReasonOptions: { i18nKey: string; value: string }[];

  ngOnInit(): void {
    super.ngOnInit();
    if (this.triggerChoices?.rules?.length >= 1) {
      const cancelReasonRule = Rule.fromRuleInterface(this.triggerChoices.rules[0]) as StringEquals;
      this.cancelReason = cancelReasonRule.value;
    }

    this.cancelReasonOptions = [
      {
        i18nKey: 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_FREE_TRIAL_CANCELLATION_REASON.CANCEL_REASON_FORM.ANY',
        value: '*',
      },
    ].concat(PartnerFreeTrialCancellationReasons);

    this.savingEnabled$.next(true);
  }

  getBaseRules(): RuleInterface[] {
    return [];
  }

  fillRuleValues(_rules: RuleInterface[]): RuleInterface[] {
    const reasonRule = new StringEquals('{.reason}', this.cancelReason, '');
    return [reasonRule.toRuleInterface()];
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
